import { Button as ButtonAntD } from 'antd';
import styled from 'styled-components';

export const Div = styled.div`
  display: flex;
  flex: 1;
  min-height: 300px;
  flex-direction: column;
`;

export const SelectContainer = styled(Div)`
  justify-content: center;
  align-items: center;
`;

export const SelectedItemContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
`;

export const AddSelectContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  align-self: flex-end;
`;

export const ThrashButton = styled(ButtonAntD)`
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 8px;
  background-color: #f3f4f7;
  border-width: 0px;
  margin-left: 8px;
`;

export const EmptyContainer = styled.div``;

export const SelectedUsersContainer = styled.div`
  display: flex;
  flex-direction: column;

  .search_cpf_button {
    margin: 0 0 16px 0px;
  }
`;

export const SelectedUsersCount = styled.h2``;

export const Button = styled(ButtonAntD)`
  display: flex;
  align-items: center;
  align-self: flex-end;
  padding: 16px;

  &.ant-btn-primary {
    background-color: ${({ theme }) => theme.primary};
    border-color: ${({ theme }) => theme.primary};
  }

  &.ant-btn:not(.ant-btn-primary) {
    &:hover,
    &:focus,
    &:active {
      border-color: ${({ theme }) => theme.primary};
      color: ${({ theme }) => theme.primary};
    }
  }
`;

export const Footer = styled.div`
  display: flex;
  align-items: flex-end;
  justify-content: flex-end;
`;

export const RoundedButton = styled(ButtonAntD)`
  display: flex;
  border-radius: 16px;
  padding: 8px;
  margin-bottom: 4px;
  margin-right: 4px;

  &.ant-btn-primary {
    background-color: ${({ theme }) => theme.primary};
    border-color: ${({ theme }) => theme.primary};
  }
`;
